var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.622V7.37824C20.9993 7.24472 20.9634 7.11375 20.8959 6.99853C20.8284 6.88331 20.7317 6.78793 20.6156 6.72199L12.3656 2.08137C12.2545 2.01719 12.1284 1.9834 12 1.9834C11.8716 1.9834 11.7455 2.01719 11.6344 2.08137L3.38437 6.72199C3.26827 6.78793 3.1716 6.88331 3.10411 6.99853C3.03663 7.11375 3.00072 7.24472 3 7.37824V16.622C3.00072 16.7555 3.03663 16.8865 3.10411 17.0017C3.1716 17.1169 3.26827 17.2123 3.38437 17.2782L11.6344 21.9189C11.7455 21.983 11.8716 22.0168 12 22.0168C12.1284 22.0168 12.2545 21.983 12.3656 21.9189L20.6156 17.2782C20.7317 17.2123 20.8284 17.1169 20.8959 17.0017C20.9634 16.8865 20.9993 16.7555 21 16.622V16.622Z",
    stroke: "#007DF2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5938 14.2969V9.42188L7.5 4.40625",
    stroke: "#007DF2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8973 6.99365L12.0848 11.9999L3.10352 6.99365",
    stroke: "#007DF2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0844 12L12 22.0125",
    stroke: "#007DF2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBox);
export default __webpack_public_path__ + "static/media/blueBox.f814b509721943f5d43845fbaf7d7551.svg";
export { ForwardRef as ReactComponent };